/*
* Slider Reviews
*/
const sdliderCount = () => {
	const $status = $('.slider__count');
	const $sliderReviews = $('#slider-reviews .slider__slides');

	$sliderReviews.on('init', function (event, slick, currentSlide, nextSlide) {
		const $stars = $('#slider-reviews .list-stars');
		$('#slider-reviews .slider__slide .slider__slide-content').prepend($stars);
	});

	$sliderReviews.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
		let i = (currentSlide ? currentSlide : 0) + 1;
		$status.text(i + '/' + slick.slideCount);
	});
}

sdliderCount();
